import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { TeamQuery } from "../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const team = graphql(`
  query team {
    team {
      id
      name
      metadata {
        defaultSearchTopic
      }
      users {
        guid
        firstName
        lastName
      }
    }
  }
`);

export function useTeam(options?: UseQueryOptions<TeamQuery, unknown, TeamQuery, QueryKey>) {
  const { data, ...rest } = useGraphQlQuery(["team"], team, [], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    ...options,
  });

  return { data: data?.team, ...rest };
}
